import { render, staticRenderFns } from "./CreatePaystubModal.vue?vue&type=template&id=76d21576&scoped=true&"
import script from "./CreatePaystubModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePaystubModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d21576",
  null
  
)

export default component.exports